module.exports = __webpack_public_path__ + "img/P150T_weapon_93.df394bc6.png";